import { Autocomplete, Button, Card, Checkbox, Stack, TextField, Typography } from '@material-ui/core';
import { CheckBox, TextFields } from '@material-ui/icons';
import { Form, FormikProvider, useFormik } from 'formik';
import * as Yup from 'yup';
import { useEffect, useState } from 'react';
import { LoadingButton } from '@material-ui/lab';
import InnerForm from './InnerForm';
import InnerBody from './InnerBody';

export default function ProjectConfigForm() {
  const top100Films = ['Client1', 'Client2', 'Client3'];
  const selectProject = ['Project1', 'Project2', 'Project3'];
  const [fields, setFields] = useState(null);
  const [checkDisable, setCheckDisable] = useState(false);
  const [isShown, setIsShown] = useState(false);
  // const handleClick = () => setShowComponent(!showComponent);
  // const array1 = [1, 2, 3, 4];

  const NewUserSchema = Yup.object().shape({
    noOfSegment: Yup.number().required('*Please enter No. of Aging Buckets')
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      noOfAgingBuckets: ''
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, setErrors }) => {
      try {
        setFields(parseInt(values.noOfAgingBuckets, 10));
        setSubmitting(false);
      } catch (error) {
        console.error(error);
        setSubmitting(false);
        setErrors(error);
      }
    }
  });
  const { errors, touched, handleSubmit, getFieldProps } = formik;

  // const handleChange = (event) => {
  //   const { key } = event;
  //   const { name } = event.target;
  //   if (name === 'agingBuckets') {
  //     if (key === 'Backspace' || key === 'Delete') {
  //       console.log('BackValue', event.target.value);
  //       setFields(0);
  //       console.log('BackSpace', fields);
  //     }
  //     if (key === 'Enter') {
  //       setFields(parseInt(event.target.value, 10));
  //       console.log('BackSEnter', fields);
  //     }

  //     console.log('name', name);
  //     if (name === 'checkBox') {
  //       if (key === 'checked') {
  //         console.log('event', event);
  //         setFields(true);
  //       }
  //     }
  //   } else if (name === 'accountExpire') {
  //     console.log('name', name);
  //   }
  // };
  const handleClick = (event) => {
    setIsShown((current) => !current);
  };
  return (
    <FormikProvider value={formik}>
      <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
        <Card sx={{ p: 3 }}>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
            <Autocomplete
              fullWidth
              options={top100Films}
              getOptionLabel={(option) => option}
              renderInput={(params) => <TextField {...params} label="Select Client" margin="none" />}
            />
            <Autocomplete
              fullWidth
              options={selectProject}
              getOptionLabel={(option) => option}
              renderInput={(params) => <TextField {...params} label="Select Project" margin="none" />}
            />
          </Stack>
          <Button fullWidth sx={{ marginTop: 2 }} onClick={handleClick}>
            Go
          </Button>
          {isShown && <InnerBody />}

          {/* <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={{ xs: 3, sm: 2 }}
            sx={{ marginTop: 2 }}
            alignItems="center"
          >
            <TextField
              name="accountExpire"
              onChange={handleChange}
              label="Expiration Of Accounts"
              disabled={checkDisable}
            />
            <Checkbox name="checkBox" onChange={() => setCheckDisable(!checkDisable)} />
            <Typography>No Expiration</Typography>
          </Stack>
          <Stack sx={{ marginTop: 2 }}>
            <TextField
              name="agingBuckets"
              onChange={handleChange}
              onKeyDown={handleChange}
              // value={fields}
              label="Number of Payment Aging Buckets"
            />
          </Stack>
          <Stack sx={{ marginTop: 4 }}>
            <h4>Aging Buckets</h4>
          </Stack>
          {(fields !== null || Number.isNaN(fields)) &&
            [...Array(fields)].map((data, index) => <InnerForm index={index} />)}

          <Stack direction="row-reverse">
            <LoadingButton variant="outlined" direction={{ xs: 'column', sm: 'row' }} sx={{ marginTop: 2 }}>
              Save
            </LoadingButton>
          </Stack> */}
        </Card>
      </Form>
    </FormikProvider>
  );
}
